import React, {Component} from 'react';
import Accordion from 'react-bootstrap/Accordion';
import 'assets/sass/user/configuration/ConfigItem.scss';

export class ConfigItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.toggleCollapse = this.toggleCollapse.bind(this)
    }

    toggleCollapse() {
        const lastState = this.state.isOpen;
        this.setState({isOpen: !lastState});
    }

    render() {
        return (
            <div className={'config-item' + (this.state.isOpen ? ' open' : '')}>
                <Accordion>
                    <Accordion.Toggle as="div" variant="link" eventKey="1" onClick={this.toggleCollapse}>
                        <div className="config-header">
                            <div className="header-item">
                                <figure className="icon"><img src={this.props.icon} alt=""/></figure>
                                <div className="title">
                                    <h5>{this.props.title}</h5>
                                    <div className="subtitle">{this.props.subtitle}</div>
                                </div>
                            </div>
                            <div className="header-arrow"></div>
                        </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="1">
                        <div className="config-content">
                            {this.props.children}
                        </div>
                    </Accordion.Collapse>
                </Accordion>
            </div>
        );
    }
}
